import { render, staticRenderFns } from "./SkillCategoriesTable.vue?vue&type=template&id=fb20d522&"
import script from "./SkillCategoriesTable.vue?vue&type=script&lang=js&"
export * from "./SkillCategoriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports